const TwoFactorAuthLevels = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY'
};
export default TwoFactorAuthLevels;